import { __assign, __awaiter, __decorate, __extends, __generator, __spreadArrays } from "tslib";
import * as React from 'react';
import { SearchInput } from './search-input';
import { SearchSuggestionsContainer } from './search-suggestions-container';
import { config } from '../../config';
import { Path } from '../../enums/marketplace-enums';
import { WithFocusIndication, } from '../../component-decorators/with-focus-indication';
import { withMarketplaceStore, } from '../../component-decorators/with-marketplace-store';
import { withBiLogger } from '../../component-decorators/with-bi-logger';
import ReactDOM from 'react-dom';
import { getAutocompleteAppsByQuery } from '../../api/api';
import { getCategoriesByQuery } from './search-suggestions-container/static-data/categories-searches';
import { defaultSuggestions as defaultSuggestionsData } from './search-suggestions-container/static-data/default-suggestions';
import { autorun } from 'mobx';
import { withTranslation } from '../../component-decorators/with-translation';
import { getPathForBi } from '../../common/bi-events';
import { SuggestionType, } from '../../types/common/marketplace';
var SearchBoxContainer = /** @class */ (function (_super) {
    __extends(SearchBoxContainer, _super);
    function SearchBoxContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            fetchedData: false,
            value: '',
            isLoading: false,
            suggestionsList: _this.fetchDefaultSuggestions(),
            clearedSearchAtDate: Date.now(),
        };
        _this.onSearchInputEnter = _this.onSearchInputEnter.bind(_this);
        _this.onSearchInputValueChange = _this.onSearchInputValueChange.bind(_this);
        _this.addAndRemoveSelectedNode = _this.addAndRemoveSelectedNode.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.searchInputOnclickHandler = _this.searchInputOnclickHandler.bind(_this);
        _this.clearSearchInput = _this.clearSearchInput.bind(_this);
        _this.sendSearchSearchClickBi = _this.sendSearchSearchClickBi.bind(_this);
        autorun(function () {
            if (props.marketplaceStore.clearSearchBeforeDate >
                _this.state.clearedSearchAtDate) {
                _this.clearSearchInput();
            }
        });
        return _this;
    }
    SearchBoxContainer.prototype.fetchDefaultSuggestions = function () {
        return defaultSuggestionsData.map(function (item, index) {
            return __assign(__assign({}, item), { selected: false, index: index });
        });
    };
    SearchBoxContainer.prototype.clearSearchInput = function () {
        this.setState({
            value: '',
            clearedSearchAtDate: Date.now(),
            suggestionsList: this.fetchDefaultSuggestions(),
        });
    };
    SearchBoxContainer.prototype.setScrollPositions = function (suggestionsList) {
        var node = ReactDOM.findDOMNode(this);
        var suggestionsElements = node.querySelectorAll('.suggestion');
        suggestionsElements.forEach(function (el, index) {
            var offset = el.offsetParent.clientHeight - (el.offsetTop + el.clientHeight);
            var scrollPosition = offset >= 0 ? 0 : offset * -1;
            suggestionsList[index] = __assign(__assign({}, suggestionsList[index]), { scrollPosition: scrollPosition });
        });
        return suggestionsList;
    };
    SearchBoxContainer.prototype.onSearchInputValueChange = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, marketplaceStore, biLogger, setFocus, suggestionsList;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, marketplaceStore = _a.marketplaceStore, biLogger = _a.biLogger, setFocus = _a.setFocus;
                        setFocus(true);
                        this.setState({ isLoading: true, value: value });
                        if (!(value === '')) return [3 /*break*/, 1];
                        suggestionsList = this.fetchDefaultSuggestions();
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.fetchData(this.props.t(value))];
                    case 2:
                        suggestionsList = _b.sent();
                        suggestionsList.forEach(function (item) {
                            if (item.type === SuggestionType.APP) {
                                biLogger.appMarketAppImpression({
                                    app_id: item.id,
                                    market: config.originForBI,
                                    msid: marketplaceStore.metaSiteId,
                                    impression_type: 'search',
                                    section: 'app_suggestion',
                                    tag_type: 'search_bar',
                                    search_term: value,
                                });
                            }
                        });
                        _b.label = 3;
                    case 3:
                        this.setState({
                            suggestionsList: suggestionsList,
                            fetchedData: true,
                            value: value,
                            isLoading: false,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchBoxContainer.prototype.onSearchInputEnter = function (value) {
        var _a = this.props, marketplaceStore = _a.marketplaceStore, biLogger = _a.biLogger, setFocus = _a.setFocus;
        var node = ReactDOM.findDOMNode(this);
        var selectedSuggestion = node.querySelector('.selected');
        if (selectedSuggestion) {
            selectedSuggestion.click();
        }
        else {
            this.sendSearchSearchClickBi(value, 'direct');
            setFocus(false);
            config.goto({ path: Path.SEARCH, query: value });
        }
    };
    SearchBoxContainer.prototype.addAndRemoveSelectedNode = function (newIndex) {
        var suggestionsList = this.state.suggestionsList;
        var prevIndex = 0;
        var updatedList = suggestionsList.map(function (item, index) {
            if (item.selected) {
                prevIndex = index;
                return __assign(__assign({}, item), { selected: false });
            }
            return item;
        });
        if (newIndex !== null && newIndex !== undefined) {
            updatedList[newIndex] = __assign(__assign({}, updatedList[newIndex]), { selected: true });
        }
        this.setState({ suggestionsList: updatedList });
    };
    SearchBoxContainer.prototype.setScrollPosition = function (suggestionsList, index) {
        var node = ReactDOM.findDOMNode(this);
        var suggestionsContainer = node.querySelector('.suggestionsContainer');
        if (suggestionsContainer) {
            suggestionsContainer.scrollTop = suggestionsList[index].scrollPosition;
        }
    };
    SearchBoxContainer.prototype.onKeyDown = function (e) {
        var suggestionsList = this.state.suggestionsList;
        var prevIndex = suggestionsList.findIndex(function (item) { return item.selected; });
        var suggestionsLength = suggestionsList.length;
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            var newIndex = 0;
            if (e.key === 'ArrowDown' && prevIndex >= 0) {
                newIndex = (prevIndex + 1) % suggestionsLength;
            }
            if (e.key === 'ArrowUp') {
                newIndex = suggestionsLength - 1;
                if (prevIndex >= 0) {
                    newIndex = (prevIndex + suggestionsLength - 1) % suggestionsLength;
                }
            }
            this.addAndRemoveSelectedNode(newIndex);
            this.setScrollPosition(suggestionsList, newIndex);
        }
    };
    // setLoading(value) {
    //   this.setState({ isLoading: value });
    // }
    SearchBoxContainer.prototype.fetchData = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var autocompleteSuggestions, appsSuggestion, apps, categories, popularSearchesResponse, popularSearches;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getAutocompleteAppsByQuery(value, this.props.locale)];
                    case 1:
                        autocompleteSuggestions = _a.sent();
                        appsSuggestion = autocompleteSuggestions.suggestions;
                        apps = appsSuggestion.map(function (app) {
                            return __assign(__assign({}, app), { suggestionType: SuggestionType.APP, selected: false });
                        });
                        categories = getCategoriesByQuery(value);
                        categories = categories.map(function (category) {
                            return __assign(__assign({}, category), { suggestionType: SuggestionType.CATEGORY, selected: false });
                        });
                        popularSearchesResponse = autocompleteSuggestions.autocomplete;
                        popularSearches = popularSearchesResponse.map(function (popular) { return ({
                            name: popular,
                            suggestionType: SuggestionType.SEARCH,
                            selected: false,
                        }); });
                        return [2 /*return*/, __spreadArrays(popularSearches, apps, categories).map(function (suggestion, index) {
                                return __assign(__assign({}, suggestion), { index: index });
                            })];
                }
            });
        });
    };
    SearchBoxContainer.prototype.searchInputOnclickHandler = function () {
        var _a = this.props, setFocus = _a.setFocus, biLogger = _a.biLogger, marketplaceStore = _a.marketplaceStore;
        biLogger.searchSearchFocus({
            market: config.originForBI,
            msid: marketplaceStore.metaSiteId,
            search_location: this.props.isInMenu ? 'sidebar_search' : 'main_search',
        });
        setFocus(true);
    };
    SearchBoxContainer.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var suggestionsList = this.state.suggestionsList;
        if (prevState.suggestionsList !== suggestionsList) {
            this.setScrollPositions(suggestionsList);
        }
    };
    SearchBoxContainer.prototype.sendSearchSearchClickBi = function (search_term, search_type, index) {
        var _a = this.props, biLogger = _a.biLogger, marketplaceStore = _a.marketplaceStore, isInMenu = _a.isInMenu;
        biLogger.searchSearchClick({
            market: config.originForBI,
            search_term: search_term,
            msid: marketplaceStore.metaSiteId,
            search_type: search_type,
            search_location: isInMenu ? 'sidebar_search' : 'main_search',
            index: index,
            tag_type: getPathForBi(this.props.marketplaceStore.route.path),
        });
    };
    SearchBoxContainer.prototype.render = function () {
        var _a = this.props, isFocused = _a.isFocused, setFocus = _a.setFocus, locale = _a.locale;
        var _b = this.state, suggestionsList = _b.suggestionsList, fetchedData = _b.fetchedData, value = _b.value;
        return (React.createElement("div", { "data-testid": 'search-box-container', onKeyDownCapture: this.onKeyDown, style: { width: 'fit-content' } },
            React.createElement("div", { onClick: this.searchInputOnclickHandler },
                React.createElement(SearchInput, { onSearchInputEnter: this.onSearchInputEnter, searchValue: value, onSearchValueChange: this.onSearchInputValueChange, isLoading: this.state.isLoading, isInMenu: this.props.isInMenu, isInHeader: this.props.isInHeader, isExpandable: this.props.isExpandable })),
            isFocused && (React.createElement("div", { onClick: function () { return setFocus(false); } },
                React.createElement(SearchSuggestionsContainer, { onSearchValueChange: this.onSearchInputValueChange, searchValue: value, suggestions: suggestionsList, addSelectedNode: this.addAndRemoveSelectedNode, fetchedData: fetchedData, sendSearchSearchClickBi: this.sendSearchSearchClickBi, isInHeader: this.props.isInHeader })))));
    };
    SearchBoxContainer = __decorate([
        withBiLogger,
        withMarketplaceStore,
        WithFocusIndication({ init: false }),
        withTranslation
    ], SearchBoxContainer);
    return SearchBoxContainer;
}(React.Component));
export { SearchBoxContainer };
//# sourceMappingURL=search-box-container.js.map